import { Button } from '@shared/components/shadcn';
import { PaymentError } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useMultistepForm } from '../../../../../form-controls/MultistepForm/hooks/useMultistepForm';
import { usePaymentLimitImpressionTracking } from '../../../hooks/usePaymentLimitImpressionTracking';
import type { ErrorStepProps } from '../../types';

function ErrorStep({ errorMessage, errorKey, onRetry, ...props }: ErrorStepProps) {
  const t = useTranslations('global_sheets.deposit.error_step');
  const { setStatus, skipToStep, setIsLoading } = useMultistepForm();
  const impressionName = usePaymentLimitImpressionTracking(errorKey);

  const handleRetry = () => {
    setIsLoading(false);
    setStatus('');
    skipToStep('amount');
    onRetry();
  };

  // TODO: Remove the comment in scope of adding the progress indicator
  // const renderProgressIndicator = () => {
  //   return (
  //     <div className="flex flex-col">
  //       {/* Step 1 - Processing deposit (Active) */}
  //       <div className="flex items-center gap-4">
  //         <div className={cn('w-8 h-8 rounded-full flex items-center justify-center', errorStep === 'PROCESSING_DEPOSIT' ? 'bg-error-background' : 'bg-container')}>
  //           {errorStep === 'PROCESSING_DEPOSIT' ? <Clock className="w-4 h-4 text-error-foreground" /> : <span className="text-foreground paragraph-explanatory-strong">1</span>}
  //         </div>
  //         <span className="text-foreground paragraph-strong">{t('progress.step1')}</span>
  //       </div>

  //       {/* Separator */}
  //       <div className="flex items-center justify-center h-10 w-8">
  //         <div className="w-px h-10 bg-container-secondary"></div>
  //       </div>

  //       {/* Step 2 - Payment sent (Completed) */}
  //       <div className="flex items-center gap-4">
  //         <div className={cn('w-8 h-8 rounded-full flex items-center justify-center', errorStep === 'PAYMENT_SENT' ? 'bg-error-background' : 'bg-container')}>
  //           {errorStep === 'PAYMENT_SENT' ? <Clock className="w-4 h-4 text-error-foreground" /> : <span className="text-foreground paragraph-explanatory-strong">2</span>}
  //         </div>
  //         <span className="text-foreground paragraph-strong">{t('progress.step2')}</span>
  //       </div>

  //       {/* Separator */}
  //       <div className="flex items-center justify-center h-12 w-8">
  //         <div className="w-px h-12 bg-container-secondary"></div>
  //       </div>

  //       {/* Step 3 - Deposit complete (Completed) */}
  //       <div className="flex items-center gap-4">
  //         <div className={cn('w-8 h-8 rounded-full flex items-center justify-center', errorStep === 'DEPOSIT_COMPLETE' ? 'bg-error-background' : 'bg-container')}>
  //           {errorStep === 'DEPOSIT_COMPLETE' ? <Clock className="w-4 h-4 text-error-foreground" /> : <span className="text-foreground paragraph-explanatory-strong">3</span>}
  //         </div>

  //         <span className="text-foreground paragraph-strong">{t('progress.step3')}</span>
  //       </div>
  //     </div>
  //   );
  // };

  return (
    <div className="w-full flex flex-col flex-1 gap-8 px-4" data-testid="error-step" {...(impressionName ? { 'data-impression': impressionName } : {})} {...props}>
      <div className="flex flex-col gap-5">
        <PaymentError className="size-16" />
        <div className="flex flex-col gap-2">
          <h4>{t('title')}</h4>
          <p className="text-foreground-subtle" data-track-name="Reason">
            {errorMessage ?? t('description')}
          </p>
        </div>
      </div>

      {/* TODO: Remove the comment in scope of adding the progress indicator */}
      {/* renderProgressIndicator() */}

      <div className="flex flex-col gap-4 mt-auto md:mt-0" data-track-container="Actions">
        <Button type="button" variant="secondary" onClick={handleRetry} className="w-full h-10" data-testid="retry-button" data-track-name="Retry">
          {t('retry_button')}
        </Button>
      </div>
    </div>
  );
}

export { ErrorStep };
